// modules/equal-grid-height-headers.js

/**
 * Imposta la stessa altezza per i titoli nei vari componenti (cards-grid, expanding-cards, ecc.).
 * - Usa la classe css `.js-equalize-header` sugli <header> da allineare.
 * - Ricalcola al resize della finestra
 * 
 */
export function setEqualHeightHeaders() {
    const sections = document.querySelectorAll(".cards-grid, .expanding-cards");

    if (!sections || sections.length === 0) {
        console.log("[setEqualHeightHeaders] Nessuna sezione trovata");
        return;
    }

    console.log(
        `[setEqualHeightHeaders] Trovate ${sections.length} sezioni 👍`
    );

    const applyEqualHeight = () => {
        sections.forEach((section, i) => {
            const headers = section.querySelectorAll(".js-equalize-header");

            if (!headers || headers.length === 0) return;

            let maxHeight = 0;

            // Reset
            headers.forEach((h) => (h.style.minHeight = ""));

            /**
             * OPZIONALE:
             * Disabilitare l'allineamento su mobile (se le card sono impilate),
             */
            /*
            if (window.innerWidth < 992) {
                return;
            }
            */

            // Calcola max
            headers.forEach((h) => {
                maxHeight = Math.max(maxHeight, h.offsetHeight);
            });

            console.log(
                `[setEqualHeightHeaders] Sezione ${i + 1
                }: altezza massima ${maxHeight}px`
            );

            headers.forEach((h, i) => {
                h.style.minHeight = `${maxHeight}px`;
                console.log(
                    `[setEqualHeightHeaders] → header ${i + 1
                    } minHeight ${maxHeight}px`
                );
            });
        });
    };

    // Inizializza
    applyEqualHeight();

    // Ricalcola al resize con debounce
    let resizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        console.log("[setEqualHeightHeaders] Evento resize → ricalcolo...");
        resizeTimer = setTimeout(applyEqualHeight, 150);
    });
}
